(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHero = (hero) => {
      if (hero.dataset.jcHeroInitialized === 'true') return;
      hero.dataset.jcHeroInitialized = 'true';

      const toggle = hero.querySelector('[data-jc-video-toggle]');
      if (!toggle) return;

      const getActiveVideos = () => {
        return Array.from(hero.querySelectorAll('video')).filter((video) => {
          const mediaItem = video.closest('.jc-hero__media-item');
          return mediaItem && window.getComputedStyle(mediaItem).display !== 'none';
        });
      };

      const updateButton = (paused) => {
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      };

      toggle.addEventListener('click', () => {
        const videos = getActiveVideos();
        const shouldPlay = videos.some((video) => video.paused);

        videos.forEach((video) => {
          if (shouldPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        updateButton(!shouldPlay);
      });

      const syncControl = () => {
        const activeVideos = getActiveVideos();
        toggle.hidden = activeVideos.length === 0;
        updateButton(activeVideos.length > 0 && activeVideos.every((video) => video.paused));
      };

      hero.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', syncControl);
        video.addEventListener('pause', syncControl);
      });

      syncControl();
      window.addEventListener('resize', syncControl, { passive: true });
    };

    const initializeAllHeroes = (root = document) => {
      root.querySelectorAll('[data-jc-hero]').forEach(initializeHero);
    };

    initializeAllHeroes();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllHeroes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xilie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSeries = (root) => {
      if (!root || root.dataset.jcSeriesInitialized === 'true') return;
      root.dataset.jcSeriesInitialized = 'true';

      const track = root.querySelector('[data-jc-series-track]');
      const previous = root.querySelector('[data-jc-series-prev]');
      const next = root.querySelector('[data-jc-series-next]');

      const getScrollStep = () => {
        const card = track && track.querySelector('.jc-series-card:not(.jc-series-card--hide-mobile)');
        if (!track || !card) return 0;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        if (!track || !previous || !next) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      if (track && previous && next) {
        previous.addEventListener('click', () => {
          track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);
        updateControls();
      }

      if (root.classList.contains('jc-series--reveal')) {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                root.classList.add('jc-series--visible');
                observer.disconnect();
              }
            });
          }, { threshold: 0.12 });
          observer.observe(root);
        } else {
          root.classList.add('jc-series--visible');
        }
      }
    };

    const initializeAllSeries = (scope = document) => {
      scope.querySelectorAll('[data-jc-series]').forEach(initializeSeries);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllSeries());
    } else {
      initializeAllSeries();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllSeries(event.target);
      if (event.target.matches && event.target.matches('[data-jc-series]')) {
        initializeSeries(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xilie2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSeries = (root) => {
      if (!root || root.dataset.jcSeriesInitialized === 'true') return;
      root.dataset.jcSeriesInitialized = 'true';

      const track = root.querySelector('[data-jc-series-v2-track]');
      const previous = root.querySelector('[data-jc-series-v2-prev]');
      const next = root.querySelector('[data-jc-series-v2-next]');

      const getScrollStep = () => {
        const card = track && track.querySelector('.jc-series-v2-card:not(.jc-series-v2-card--hide-mobile)');
        if (!track || !card) return 0;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        if (!track || !previous || !next) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      if (track && previous && next) {
        previous.addEventListener('click', () => {
          track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);
        updateControls();
      }

      if (root.classList.contains('jc-series-v2--reveal')) {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                root.classList.add('jc-series-v2--visible');
                observer.disconnect();
              }
            });
          }, { threshold: 0.12 });
          observer.observe(root);
        } else {
          root.classList.add('jc-series-v2--visible');
        }
      }
    };

    const initializeAllSeries = (scope = document) => {
      scope.querySelectorAll('[data-jc-series-v2]').forEach(initializeSeries);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllSeries());
    } else {
      initializeAllSeries();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllSeries(event.target);
      if (event.target.matches && event.target.matches('[data-jc-series-v2]')) {
        initializeSeries(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
